<template lang="pug">
  footer
    .container.mx-auto
      Menu#footer-menu(k="footer-menu", :max-depth="1")
      .socialmedia
        a(href="https://www.instagram.com/ercklentz.kempen/" target="_blank" rel="noopener" alt="Instagram" title="Instagram")
            font-awesome-icon.icon-fb(:icon="['fab', 'instagram']")
        a(href="https://www.facebook.com/RestaurantErcklentz" target="_blank" rel="noopener" alt="Facebook" title="Facebook")
            font-awesome-icon.icon-fb(:icon="['fab', 'facebook-f']")
</template>

<script>
import { mapGetters } from 'vuex';
import Menu from '@/components/Menu.vue';

export default {
    name: 'Footer',
    components: {
        Menu
    },
    computed: {
        ...mapGetters({
            menus: 'menus',
            config: 'config',
            webpSupport: 'webpSupport'
        })
    }
};
</script>

<style lang="sass" nolang="scss" scoped>
@import "~@/assets/sass/variables"

footer
  @apply p-3
  background-color: $color-primary
  > .container
    @screen max-sm
      @apply flex justify-between

  .socialmedia
    @apply block
    @screen sm
      @apply hidden
    a > .svg-inline--fa
      @apply ml-2
      &:hover
        @apply opacity-75
  #footer-menu
    &::v-deep
      ul
        @apply flex justify-center mx-auto
        &.tree-menu
          & > li
            @apply relative
            &:last-child
              & > .tree-item a:after
                @apply hidden
            &.active > .tree-item a
              @apply font-semibold
            & > .tree-item a
              @apply transition duration-300 ease-linear
              &:after
                @apply px-2
                content: '|'
                @screen sm
                  @apply px-4
              &:hover
                @apply font-semibold
              &:hover:after
                @apply font-normal
    
</style>
